<template>
  <div class="password-login-box">
    <dl class="show-flex-box-c">
      <dt class="user-acount">
        <input type="text" placeholder="账号" autocomplete="off" v-model="curAccount">
      </dt>
      <dd class="user-pwd">
        <input type="password" placeholder="密码" autocomplete="new-password" v-model="curPwd">
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'password_login_cpn',
  data () {
    return {
      curPwd: '',       //当前输入密码
      curAccount: '',     //当前输入帐号
    }
  },
  methods: {
    postCurPwd: function() {
      this.$emit('pass-pwd-params',this.curPwd);
    },
    postCurAccount: function() {
      this.$emit('pass-account-params',this.curAccount);
    }
  },
  watch:{
    curPwd: function() {
      this.postCurPwd();
    },
    curAccount: function() {
      this.postCurAccount();
    }
  }
}
</script>

<style lang="less" scoped>
  .password-login-box{
    width: 100%;
    &>dl{
      width: 100%;
      &>dt{
        width: 100%;
        margin-bottom: 16px;
        &>input{
          width: 234px;
          height: 38px;
          padding-left: 14px;
          border: 1px solid #E5E5E5;
          background: #FAFAFA;
          color: #191D21;
          border-radius: 5px;
        }
      }
      &>dd{
        width: 100%;
        &>input{
          width: 234px;
          height: 38px;
          padding-left: 14px;
          border: 1px solid #E5E5E5;
          background: #FAFAFA;
          color: #191D21;
          border-radius: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/password_login_cpn.vue